/**
 * Validate email format
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validate OTP code (6 digits)
 */
export const isValidOTP = (code: string): boolean => {
  return /^\d{6}$/.test(code);
};

/**
 * Validate signal value
 */
export const isValidSignalValue = (value: string, type: string): boolean => {
  const numValue = parseFloat(value);

  if (isNaN(numValue)) {
    return false;
  }

  if (numValue <= 0) {
    return false;
  }

  // Percent change should be between 0.01 and 100
  if (type === 'percent_change') {
    return numValue >= 0.01 && numValue <= 100;
  }

  return true;
};

/**
 * Get validation error message
 */
export const getValidationError = (
  field: 'email' | 'otp' | 'signalValue',
  value: string,
  type?: string
): string | null => {
  switch (field) {
    case 'email':
      if (!value) return 'Email is required';
      if (!isValidEmail(value)) return 'Please enter a valid email address';
      return null;

    case 'otp':
      if (!value) return 'OTP code is required';
      if (!isValidOTP(value)) return 'OTP must be 6 digits';
      return null;

    case 'signalValue':
      if (!value) return 'Value is required';
      if (!isValidSignalValue(value, type || '')) {
        if (type === 'percent_change') {
          return 'Percentage must be between 0.01 and 100';
        }
        return 'Please enter a valid positive number';
      }
      return null;

    default:
      return null;
  }
};
